import { Container } from "react-bootstrap";
import "./css/style.css";
export default function Advantages(params) {
    return (
        <>
            <section id="advantages" className="advantages ">
                <Container className="">
                    <h2 className="advantages_title">заказывая у нас, вы получаете:</h2>
                    <p className="advantages_text t28">
                        быстрое и удобное оформление заказа на покупку LED-экрана в любое время. Гарантируем качественное оборудование, оперативную
                        обработку заявки и персонализированные решения для ваших задач
                    </p>
                    <div className="advantages_cards">
                        <div className="advantages_cards_item">
                            <p className="advantages_cards_item_title">от 60 000 ₽/м²</p>
                            <p className="advantages_cards_item_description">стоимость продажи</p>
                        </div>
                        <div className="advantages_cards_item">
                            <p className="advantages_cards_item_title">от 2-х недель</p>
                            <p className="advantages_cards_item_description">сроки поставки</p>
                        </div>
                        <div className="advantages_cards_item">
                            <p className="advantages_cards_item_title">0,9 мм</p>
                            <p className="advantages_cards_item_description">шаг пикселя ультратонкого экрана</p>
                        </div>
                        <div className="advantages_cards_item">
                            <p className="advantages_cards_item_title">0 ₽</p>
                            <p className="advantages_cards_item_description">доставка и монтаж при покупке до 10.03.25</p>
                        </div>
                    </div>

                    <a
                        className="advantages_lid flex"
                        href="https://api.whatsapp.com/send?phone=79278223311"
                        target="_blank"
                        rel="noopener noreferrer">
                        <img className="advantages_lid_img" src="/img/icon/wpColor.svg" alt="Напишите нам" />{" "}
                        <p className="t28 advantages_lid_text">Напишите нам</p>
                    </a>
                </Container>
            </section>
        </>
    );
}
